import React, { useState } from "react";
import "./AppDevelopment.scss";
import app_strategy_consulting from "../../../../Assets/Red_Theme/services/app_strategy_consulting.svg";
import innovativeAppBgImg from "../../../../Assets/Red_Theme/services/innovativeAppBgImg.png";
import fullScaleAppDevelopmentBannerImg from "../../../../Assets/Red_Theme/services/fullScaleAppDevelopmentBannerImg.svg";
import fullScaleAppDevelopmentBannerImg1 from "../../../../Assets/Red_Theme/services/fullScaleAppDevelopmentBannerImg1.svg";
import webApplicationDevelopment from "../../../../Assets/Red_Theme/services/webApplicationDevelopment.svg";
import desktopAppliationDeveloper from "../../../../Assets/Red_Theme/services/desktopAppliationDeveloper.svg";
import mobileAppDevelopment from "../../../../Assets/Red_Theme/services/mobileAppDevelopment.svg";
import iOSApplication from "../../../../Assets/Red_Theme/services/iOSApplication.svg";
import androidAppDevelopmentServices from "../../../../Assets/Red_Theme/services/androidAppDevelopmentServices.svg";
import crossPlatformAppDevelopmentServices from "../../../../Assets/Red_Theme/services/crossPlatformAppDevelopmentServices.svg";
import modernApplicationDevelopmentServices from "../../../../Assets/Red_Theme/services/modernApplicationDevelopmentServices.svg";
import applicationMaintenanceThoroughSupport from "../../../../Assets/Red_Theme/services/applicationMaintenanceThoroughSupport.svg";
import iosIcon from "../../../../Assets/Red_Theme/iosIcon.svg";
import androidIcon from "../../../../Assets/Red_Theme/androidIcon.svg";
import flutterIcon from "../../../../Assets/Red_Theme/flutterIcon.svg";
import reactIcon from "../../../../Assets/Red_Theme/reactIcon.svg";
import laravelIcon from "../../../../Assets/Red_Theme/laravelIcon.svg";
import QuoteModal from "../../../../Components/QuoteModal";
// import Swal from "sweetalert2";
// import { useForm } from "react-hook-form";
import LetDiscuss from "../../../../Components/LetDiscuss";

function AppDevelopment() {
  const [isOpen, setOpen] = useState(false);
  const [subject, setSubject] = useState(null);
  // const [loading, setLoading] = useState(false);
  // const { register, handleSubmit } = useForm();
  const OpenModal = (data) => {
    setSubject(data);
    setOpen(true);
  };

  // const onSubmit = async (data) => {
  //   setLoading(true);
  //   try {
  //     const response = await fetch(
  //       `https://vidhaninfotech.com/smtptester/mailsend.php`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(data),
  //       }
  //     );

  //     if (response.status === 200) {
  //       Swal.fire({
  //         title: "Good job!",
  //         text: "We received your request, We will respond soon!",
  //         icon: "success",
  //       });
  //       setLoading(false);
  //     } else {
  //       Swal.fire({
  //         icon: "error",
  //         title: "Oops...",
  //         text: "Something went wrong!",
  //       });
  //       setLoading(false);
  //     }
  //   } catch (error) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "Something went wrong!",
  //     });
  //     setLoading(false);
  //   }
  // };
  return (
    <>
      <section className="appDevelopment">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="appdevelopment_header_content">
                <h1>
                  End-to-End <span>Custom</span> Application Development
                </h1>
                <p>
                  From conceptual design to development, rigorous testing, and
                  seamless deployment, we optimize the entire application
                  lifecycle to accelerate innovation. Partner with us as your
                  trusted Application Development Company, delivering tailored
                  solutions that align with your business goals.
                </p>
                <button
                  className="theme_btn py-2"
                  onClick={() =>
                    OpenModal("End-to-End Custom Application Development")
                  }
                >
                  <span>Get In Touch Today</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="appStrategyConsulting">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <img
                src={app_strategy_consulting}
                alt="app_strategy_consulting"
                title="app_strategy_consulting"
                className="img-fluid"
              />
            </div>
            <div className="col-lg-6 mt-lg-0 mt-4">
              <div className="appdevelopment_header_content">
                <h1>
                  App Strategy and <span>Consulting</span>
                </h1>
                <div className="mb-3">
                  <h2 className="subTitle">Expert Guidance:</h2>
                  <p>
                    Our consultants help you craft a clear and strategic app
                    roadmap, guiding you from concept to deployment. We provide
                    deep insights into market trends, competitor strategies, and
                    the ideal tech stack tailored to your project’s success.
                  </p>
                </div>
                <div className="mb-3">
                  <h2 className="subTitle">Roadmap Development:</h2>
                  <p>
                    Our team crafts a structured roadmap, detailing development
                    processes, timelines, and key milestones to ensure a
                    seamless transition from idea to app launch.
                  </p>
                </div>
                <div className="mb-3">
                  <h2 className="subTitle">Technological Expertise:</h2>
                  <p>
                    We assist you in choosing the ideal technology stack that
                    aligns with your business goals while ensuring scalability
                    and top-tier performance.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="innovativeApp">
        <div className="container">
          <div className="col-md-12">
            <div className="box">
              <img src={innovativeAppBgImg} className="boxPettern" alt="" />
              <h2>
                Innovative App Development for Better <span>Engagement</span> &
                Performance
              </h2>
              <p>
                Boost Conversions, ROI, and Engagement with Our App Development
                Consulting
              </p>
              <button
                className="theme_btn"
                onClick={() =>
                  OpenModal(
                    "Innovative App Development for Better Engagement & Performance"
                  )
                }
              >
                <span>Contact Us Today</span>
              </button>
            </div>
          </div>
        </div>
      </section>
      <section className="fullScaleAppDevelopment">
        <div className="container">
          <div className="appdevelopment_header_content">
            <h2>
              <span>AllianTek’s</span> Full-Scale App Development Services
            </h2>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-6">
              <img
                src={fullScaleAppDevelopmentBannerImg}
                alt="fullScaleAppDevelopmentBannerImg"
                title="fullScaleAppDevelopmentBannerImg"
                className="img-fluid"
              />
            </div>
            <div className="col-lg-6">
              <div className="rightMainBox">
                <div className="innerBox">
                  <div className="icon">
                    <img
                      src={webApplicationDevelopment}
                      alt="webApplicationDevelopment"
                      title="webApplicationDevelopment"
                      className="img-fluid"
                    />
                  </div>
                  <div className="contain">
                    <h4>Web Application Development Services</h4>
                    <p>
                      Our tailored web application development services are
                      designed to digitize your business operations, enhance
                      transactions, improve customer service, and deliver
                      cutting-edge digital solutions.
                    </p>
                  </div>
                </div>
                <div className="innerBox">
                  <div className="icon">
                    <img
                      src={desktopAppliationDeveloper}
                      alt="desktopAppliationDeveloper"
                      title="desktopAppliationDeveloper"
                      className="img-fluid"
                    />
                  </div>
                  <div className="contain">
                    <h4>Desktop Application Development Services</h4>
                    <p>
                      Transform your workflows with high-performance desktop
                      applications. Designed for seamless integration and
                      optimized efficiency, our custom apps meet your unique
                      business demands.
                    </p>
                  </div>
                </div>
                <div className="innerBox">
                  <div className="icon">
                    <img
                      src={mobileAppDevelopment}
                      alt="mobileAppDevelopment"
                      title="mobileAppDevelopment"
                      className="img-fluid"
                    />
                  </div>
                  <div className="contain">
                    <h4>Mobile App Development Solutions</h4>
                    <p>
                      Transform your digital presence with our custom mobile app
                      solutions. Designed for iOS, Android, and Web, our
                      applications drive user engagement, enhance scalability,
                      and accelerate success.
                    </p>
                  </div>
                </div>
                <div className="innerBox">
                  <div className="icon">
                    <img
                      src={iOSApplication}
                      alt="iOSApplication"
                      title="iOSApplication"
                      className="img-fluid"
                    />
                  </div>
                  <div className="contain">
                    <h4>iOS Application Development Services</h4>
                    <p>
                      Empower your business with custom iOS app solutions. Our
                      expert team designs intuitive, scalable applications and
                      guides you from ideation to launch for a seamless user
                      experience.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row align-items-center mt-lg-5 mt-3">
            <div className="col-lg-6">
              <div className="rightMainBox">
                <div className="innerBox">
                  <div className="icon">
                    <img
                      src={androidAppDevelopmentServices}
                      alt="androidAppDevelopmentServices"
                      title="androidAppDevelopmentServices"
                      className="img-fluid"
                    />
                  </div>
                  <div className="contain">
                    <h4>Android App Development Services</h4>
                    <p>
                      Empower your business with cutting-edge Android app
                      development. Our custom mobile solutions are designed to
                      enhance user engagement, drive growth, and give you a
                      competitive edge.
                    </p>
                  </div>
                </div>
                <div className="innerBox">
                  <div className="icon">
                    <img
                      src={crossPlatformAppDevelopmentServices}
                      alt="crossPlatformAppDevelopmentServices"
                      title="crossPlatformAppDevelopmentServices"
                      className="img-fluid"
                    />
                  </div>
                  <div className="contain">
                    <h4>Cross-Platform App Development Services</h4>
                    <p>
                      Unlock new opportunities with our efficient mobile app
                      development. We build engaging, feature-rich iOS and
                      Android apps while optimizing time, cost, and
                      cross-platform accessibility.
                    </p>
                  </div>
                </div>
                <div className="innerBox">
                  <div className="icon">
                    <img
                      src={modernApplicationDevelopmentServices}
                      alt="modernApplicationDevelopmentServices"
                      title="modernApplicationDevelopmentServices"
                      className="img-fluid"
                    />
                  </div>
                  <div className="contain">
                    <h4>Modern Application Development Services</h4>
                    <p>
                      We craft tailored application development solutions that
                      enhance scalability, efficiency, and innovation. Our
                      expertise in React Native, AWS, and .NET ensures robust
                      and future-ready applications.
                    </p>
                  </div>
                </div>
                <div className="innerBox">
                  <div className="icon">
                    <img
                      src={applicationMaintenanceThoroughSupport}
                      alt="applicationMaintenanceThoroughSupport"
                      title="applicationMaintenanceThoroughSupport"
                      className="img-fluid"
                    />
                  </div>
                  <div className="contain">
                    <h4>Application Maintenance & Thorough Support</h4>
                    <p>
                      Our specialists provide round-the-clock app maintenance
                      and support, ensuring security, efficiency, and seamless
                      business operations with continuous improvements and
                      monitoring.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                src={fullScaleAppDevelopmentBannerImg1}
                alt="fullScaleAppDevelopmentBannerImg"
                title="fullScaleAppDevelopmentBannerImg"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="technologyStacks">
        <div className="container">
          <div className="appdevelopment_header_content">
            <h2>
              <span>Technology</span> Stacks Our Developers Excel in
            </h2>
          </div>
          <div className="technologyBoxes">
            <div className="box">
              <img src={iosIcon} alt="iosIcon" title="iosIcon" />
              <p>iOS</p>
            </div>
            <div className="box">
              <img src={androidIcon} alt="androidIcon" title="androidIcon" />
              <p>Android</p>
            </div>
            <div className="box">
              <img src={flutterIcon} alt="flutterIcon" title="flutterIcon" />
              <p>Flutter</p>
            </div>
            <div className="box">
              <img src={laravelIcon} alt="laravelIcon" title="laravelIcon" />
              <p>Laravel</p>
            </div>
            <div className="box">
              <img src={reactIcon} alt="reactIcon" title="reactIcon" />
              <p>React Native</p>
            </div>
          </div>
        </div>
      </section>
      <section className="otherMobileAppDevelopment">
        <div className="container">
          <div className="appdevelopment_header_content">
            <h2>
              Other Mobile App Development <span>Services</span>
            </h2>
          </div>
          <ul>
            <li>App consulting</li>
            <li>Mobile App maintenance and support</li>
            <li>Mobile App Designing</li>
            <li>Mobile App Modernization</li>
            <li>Mobile App Integration</li>
            <li>Wearable and Embedded App Development</li>
            <li>Mobile App Testing and QA</li>
            <li>Enterprise Mobile App Development</li>
          </ul>
        </div>
      </section>
      <section className="letsDiscuss">
        <div className="container">
          <div className="appdevelopment_header_content">
            <h2>
              Let&apos;s <span>Discuss</span> About Your Project
            </h2>
            <p>
              Are you looking to build a robust application that captures the
              audience&apos;s eyeballs and drives accurate results? Wait, no
              more! Our dedicated application development services are designed
              to help you upscale your business with intuitive and functional
              apps hassle-free!
            </p>
            <button
              className="theme_btn"
              onClick={() => OpenModal("Let's Discuss About Your Project")}
            >
              <span>Contact Us Now</span>
            </button>
          </div>
        </div>
      </section>
      <LetDiscuss />
      {isOpen && (
        <QuoteModal
          open={isOpen}
          setOpen={setOpen}
          CloseModal={() => setOpen(false)}
          subject={subject}
        />
      )}
    </>
  );
}
export default React.memo(AppDevelopment);
